import React, { useEffect, useState, useRef } from 'react'
import Slider from 'react-slick'
import { getSuccessStories, getToken } from 'api/request'
// import { AccessTokenContext } from 'providers/AccessToken'
import { baseUrl } from 'utils/parseDomain'
import 'styles/successStories.scss'

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  initialSlide: 0,
  lazyLoad: true,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
}

const Story = ({ storyId, img, title, description }) => {
  return (
    <section className="story">
      <img
        src={`https://img.shaadi.com/success-story/${img}`}
        alt="story"
        style={{ width: '100%', height: '225px', objectFit: 'cover' }}
      />
      <div className="storyDetail">
        <div className="storyName">{title}</div>
        <div className="storyInfo">
          {description}
          <a
            className="link text-nowrap"
            href={`${baseUrl}/shaadi-info/matrimonial-success-stories/wedding?id=${storyId}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Read more
            <span className="rightArrow" />
          </a>
        </div>
      </div>
    </section>
  )
}

const StoriesSlider = ({ storiesCriteria }) => {
  // const { token, loading } = useContext(AccessTokenContext)
  const [stories, setStories] = useState([])
  let isMounted = useRef(false)
  useEffect(() => {
    isMounted.current = true
    getToken()
      .then(getSuccessStories({ storiesCriteria }))
      .then(stories => {
        if (isMounted.current) {
          setStories(stories)
        }
      })
      .then(() =>
        setTimeout(() => {
          window.dispatchEvent(new Event('heightResize'))
        }, 100)
      )
      .catch(err => console.log('err', err))
    return () => {
      isMounted.current = false
    }
  }, [])

  return (
    <Slider {...settings}>
      {stories && stories.length > 0
        ? stories.map(story => {
            return (
              <Story
                key={story.id}
                storyId={story.id}
                img={story.photo1}
                title={story.title}
                description={
                  story.description.length > 200
                    ? `${story.description.substring(0, 200)}...`
                    : `${story.description}...`
                }
              />
            )
          })
        : null}
    </Slider>
  )
}

function SuccessStories(props) {
  return (
    <div className="storyWrapper">
      <div className="container">
        <h2 className="find_someone story_heading">{props.storiesTitle}</h2>
        <div className="row">
          <div className="col-sm-12">
            <StoriesSlider storiesCriteria={props.storiesCriteria} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default SuccessStories
